import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 99DA4752-8C79-44D8-8286-6EBD696F0B45
 * name message
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message.svg
 * tags
 */
export const MessageIcon = createSvgIcon(<><path d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z" /></>, 'MessageIcon');
export default MessageIcon